<template>
  <Head title="Avid - Login" />
  
  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <div class="row m-4 justify-content-center onboarding-new align-items-stretch">
        <div class="col-lg-9 col-12">
            <div class="row h-100 justify-content-center align-items-center flex-grow-1">
                <div class="container-fluid col-12">
                    <Link v-if="!displayAgency" class="navbar-brand" href="/">
                        <img src="/img/logo_png/avid_logo_black.png" alt="Avid" class="navbar-brand-logo-avidonly px-2">
                    </Link>
                </div>
                <div class="registration-form-container col-lg-5 col-12 mt-5 mt-lg-0 d-flex flex-column justify-content-center align-items-stretch ">
                    <div v-if="displayAgency && displayAgency.id != 44" class="d-flex cobrand-logo-container align-items-center justify-content-center w-100 mb-4">
                        <Link class="navbar-brand " href="/">
                            <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="navbar-brand-logo px-2">
                        </Link>
                        <div class="mx-3 d-flex justify-content-center align-items-center"><span class="h1 mb-0 text-primary fw-normal">&</span></div>
                        <img :src="displayAgency.logo" class="navbar-brand-logo px-2">
                    </div>
                    <Link v-else class="navbar-brand d-flex justify-content-center w-100" href="/">
                        <img src="/img/logo_png/logo_tile.png" alt="Avid" class="mb-3" style="width: 50px; height: 50px;">
                    </Link>
                    
                    <h2 class="text-center mb-4">Welcome Back</h2>
                    <form method="POST" action="/login" class="w-100">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <input type="hidden" name="redirect" :value="redirect">

                        <div class="mb-3">
                            <input id="email" type="email" placeholder="Email" class="form-control" :class="{ 'is-invalid': errors.email }" name="email" v-model="form.email" required autocomplete="email" aria-label="Email">
                            <span v-if="errors.email" class="invalid-feedback" role="alert">
                                <strong>{{ errors.email }}</strong>
                            </span>
                        </div>

                        <div class="mb-3">
                            <password-visibility 
                                :has-error="!!errors.password"
                                :error-message="errors.password ? errors.password : ''">
                            </password-visibility>
                        </div>

                        <div class="row my-3 text-center">
                            <a href="/password/reset">Forgot Password?</a>
                        </div>

                        <div class="row mt-5 mb-3">
                            <div class="col-xl-6 col-12">
                                <button type="submit" class="btn btn-primary w-100">Login</button>
                            </div>
                            <div class="col-xl-6 col-12 mt-xl-0 mt-3 d-flex justify-content-end">
                                <label class="remember-toggle w-100" for="remember">
                                    <input class="remember-toggle__input" type="checkbox" name="remember" id="remember" v-model="form.remember">
                                    <span class="remember-toggle__track w-100">
                                        <span class="remember-toggle__thumb"><i class="fa fa-check"></i></span>
                                        <span class="remember-toggle__text ps-xl-0 ps-3 ps-xxl-3">Remember Me</span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </form>

                    <div class="text-center my-4">or sign in with</div>

                    <div class="d-flex gap-3 mb-2 w-100 justify-content-center align-items-center">
                        <a href="/auth/login/google" class="btn p-0">
                            <div class="passive-blue-icon-container">
                                <img src="/img/images/google_icon.png" alt="Google" class="social-icon ms-1">
                            </div>
                        </a>
                
                        <a href="/auth/login/microsoft" class="btn p-0">
                            <div class="passive-blue-icon-container">
                                <img src="/img/images/microsoft_icon.png" alt="Microsoft" class="social-icon ms-1">
                            </div>
                        </a>

                        <a href="/auth/login/salesforce" class="btn p-0">
                            <div class="passive-blue-icon-container">
                                <img src="/img/images/salesforce_icon.png" alt="Salesforce" class="social-icon ms-1">
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 d-none d-lg-block bg-with-image"></div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { computed, reactive } from 'vue';

const props = defineProps({
  agency: {
    type: Object,
    default: null
  },
  errors: {
    type: Object,
    default: () => ({})
  }
});

const displayAgency = computed(() => {
  if (props.agency) return props.agency;
  // Note: Handling cookie-based agency display might be better done in the controller and passed as a prop
  return null;
});

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'));
const redirect = new URLSearchParams(window.location.search).get('redirect') || '';

const form = reactive({
  email: '',
  password: '',
  remember: false
});
</script>

